// extracted by mini-css-extract-plugin
export var buttons = "carousel-module--buttons--e1cd9";
export var container = "carousel-module--container--103ab";
export var content__black = "carousel-module--content__black--6e11c";
export var content__bloodorange = "carousel-module--content__bloodorange--42021";
export var content__border = "carousel-module--content__border--035ff";
export var content__centered = "carousel-module--content__centered--853b3";
export var content__chartruse = "carousel-module--content__chartruse--8cfa7";
export var content__cobalt = "carousel-module--content__cobalt--0f702";
export var content__emerald = "carousel-module--content__emerald--c74f8";
export var content__left = "carousel-module--content__left--16ea0";
export var content__paper = "carousel-module--content__paper--5d7e4";
export var content__pink = "carousel-module--content__pink--41b2c";
export var content__right = "carousel-module--content__right--b201d";
export var content__sky = "carousel-module--content__sky--afc8b";
export var content__white = "carousel-module--content__white--77a05";
export var slide = "carousel-module--slide--55570";
export var spin = "carousel-module--spin--f19fc";
export var wrapper = "carousel-module--wrapper--efd4b";